// extracted by mini-css-extract-plugin
export default {"tabSet":"style--tabSet--876885"};